/**
 * Luxembourgish localisation
 */
;(function(jQuery) {
  jQuery.fn.fdatepicker.dates.lb = {
    days: ["Sonndeg", "Méindeg", "Dënschdeg", "Mëttwoch", "Donneschdeg", "Freideg", "Samschdeg", "Sonndeg"],
    daysShort: ["Son", "Méi", "Dën", "Mët", "Don", "Fre", "Sam", "Son"],
    daysMin: ["So", "Mé", "Dë", "Më", "Do", "Fr", "Sa", "So"],
    months: ["Januar", "Februar", "Mäerz", "Abrëll", "Mee", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    monthsShort: ["Jan", "Febr", "Mrz", "Abr", "Mee", "Jun", "Jul", "Aug", "Sept", "Okt", "Nov", "Dez"],
    today: "Haut"
  };
}(jQuery));
